import React from 'react';
import { Modal } from 'semantic-ui-react';
import ReactPlayer from 'react-player/lazy';
import { VscCloseAll } from 'react-icons/vsc';

function VideoPlayer({ videoUrl, openVideoModal, setOpenVideoModal, name }) {
  const [isPlaying] = React.useState(true);
  const closeModal = () => setOpenVideoModal(false);
  return (
    <Modal centered={true} size="fullscreen" open={openVideoModal} onClose={closeModal} closeOnDimmerClick={false} closeOnEscape={false} className="bg-transparent" style={{zIndex: 1}}>
      <div className="d-flex align-items-center justify-content-between p-3 m-0 shadow-sm bg-blue-darken border-bottom">
        <span className="fw-bold fs-5 text-white"> {name}</span>
        <div data-toggle="tooltip" title="Close Video Player">
          <VscCloseAll className="text-white bg-blue-darken cursor-pointer" size={30} onClick={closeModal} />
        </div>
      </div>
      <Modal.Content className="d-flex align-items-center justify-content-center bg-dark w-100 p-0">
        <ReactPlayer 
          url={videoUrl} 
          playing={isPlaying} 
          controls={true} 
          config={{ file: { attributes: { controlsList: 'nodownload' } } }}
          onContextMenu={e => e.preventDefault()}
          className="cursor-pointer w-100" 
          width="100%" 
          height="100%" 
        />
      </Modal.Content>
    </Modal>
  );
}

export default VideoPlayer;
